


import laptop_office_nav1 from '../../assets/hero/laptop-office/nav1.png'
import laptop_office_nav2 from '../../assets/hero/laptop-office/nav2.png'
import laptop_office_nav3 from '../../assets/hero/laptop-office/nav3.png'
import laptop_office_nav4 from '../../assets/hero/laptop-office/nav4.png'
import laptop_office_nav5 from '../../assets/hero/laptop-office/nav5.png'

import laptop_gaming_nav1 from '../../assets/hero/laptop-gaming/nav1.png'
import laptop_gaming_nav2 from '../../assets/hero/laptop-gaming/nav2.png'
import laptop_gaming_nav3 from '../../assets/hero/laptop-gaming/nav3.png'
import laptop_gaming_nav4 from '../../assets/hero/laptop-gaming/nav4.png'
import laptop_gaming_nav5 from '../../assets/hero/laptop-gaming/nav5.png'

import pc_nav1 from '../../assets/hero/pc/nav1.png'
import pc_nav2 from '../../assets/hero/pc/nav2.png'
import pc_nav3 from '../../assets/hero/pc/nav3.png'
import pc_nav4 from '../../assets/hero/pc/nav4.png'

export const listImgLaptopOffice = [
    laptop_office_nav1,
    laptop_office_nav2,
    laptop_office_nav3,
    laptop_office_nav4,
    laptop_office_nav5,
]

export const listImgLaptopGaming = [
    laptop_gaming_nav1,
    laptop_gaming_nav2,
    laptop_gaming_nav3,
    laptop_gaming_nav4,
    laptop_gaming_nav5,
]

export const listImgPC = [
    pc_nav1,
    pc_nav2,
    pc_nav3,
    pc_nav4,
]